export enum TopListColumnLabels {
  PLAYER = 'Player',
  GAME = 'Game',
  BET = 'Bet',
  WIN = 'Win',
  DATE = 'Date',
  ROUND_ID = 'Round ID',
  TOTAL_BETS = 'Total bets',
  TOTAL_WINS = 'Total wins',
  GGR = 'GGR',
  NGR = 'NGR',
  RTP = 'RTP',
  INDEX = '#',
}
